document.addEventListener('DOMContentLoaded', function() {
  // Auto-accept cookies
  function acceptCookiesAutomatically() {
    // Find and click the Accept button
    const acceptButtons = document.querySelectorAll('button:contains("Accept"), button:contains("accept"), [aria-label*="Accept"], [aria-label*="accept"]');

    // Try multiple selectors for the accept button
    let found = false;

    // Try direct text content matching
    const allButtons = document.querySelectorAll('button');
    allButtons.forEach(button => {
      if ((button.textContent.includes('Accept') || button.textContent.includes('accept')) && !found) {
        button.click();
        found = true;
      }
    });

    // If not found, try other common cookie acceptance methods
    if (!found) {
      // Check for data attributes
      const acceptBtn = document.querySelector('[data-testid*="accept"], [data-testid*="Accept"]');
      if (acceptBtn) {
        acceptBtn.click();
        found = true;
      }
    }

    // If still not found, hide the banner directly
    if (!found) {
      const banner = document.querySelector('[role="alertdialog"], .cookie-banner, [data-cookie-banner]');
      if (banner) {
        banner.style.display = 'none';
      }
    }
  }

  // Run immediately
  setTimeout(acceptCookiesAutomatically, 100);
  setTimeout(acceptCookiesAutomatically, 500);
  setTimeout(acceptCookiesAutomatically, 1500);

  // Use MutationObserver to auto-accept if banner appears later
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.hasAttribute && node.hasAttribute('role') && node.getAttribute('role') === 'alertdialog') {
              setTimeout(acceptCookiesAutomatically, 50);
            } else if (node.classList && (node.classList.contains('cookie-banner') || node.classList.contains('Polaris-Modal'))) {
              setTimeout(acceptCookiesAutomatically, 50);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
